import React from 'react'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { UploadIcon } from '@/atoms/Icons/UploadIcon'
import { useTranslate } from '@/utils/translate/translate-client'
import { GButtonMD } from '@/views/PreSales/PreSalesGiveawayView/components/Typography'

interface Props {
  onClick: () => void
  className?: string
}

export const FloatingShareButton: React.FC<Props> = ({ onClick, className }) => {
  const { t } = useTranslate('tickets')

  return (
    <motion.button
      initial={{ y: 100, opacity: 0 }}
      animate={{
        y: 0,
        opacity: 1,
        transition: { type: 'tween', duration: 0.3 },
      }}
      onClick={onClick}
      className={classNames(
        'rounded-lg bg-[#F9DA8F] p-[14px] px-6 drop-shadow-md fixed flex flex-col gap-6 right-[1.5rem] z-50',
        className,
      )}
    >
      <div className="flex items-center gap-1">
        <div className="flex flex-col">
          <GButtonMD color="giveaway-primary">{t('giveawayShareV2', 'Share')}</GButtonMD>
        </div>
        <UploadIcon size={28} color="giveaway-primary" />
      </div>
    </motion.button>
  )
}
